import { reactive } from 'vue';

const state = reactive({
  /**
   * @type {Boolean} The current focus state (enabled/disabled).
   */
  enabled: false,

  /**
   * @type {String} Allows to use alternative mask variants..
   */
  variant: 'dark',
});

export default state;
